import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../../crt-route-config'

export const Route = createFileRoute(
  '/_auth/_modules/crt/customer-investments/data-sources/agreements',
)({
  staticData: toStaticData(CRT_ROUTES['/crt/customer-investments/data-sources/agreements']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
